@import 'apps/webcomponents/src/assets/common.scss';

.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 50vh;

  .grid {
    height: 100%;
    padding: 0 20px;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}
